import React, { useState, memo, useCallback } from "react";
import DragBox1 from "./DragBox1";
import DragBox2 from "./DragBox2";
import DragBox3 from "./DragBox3";
import DragBox4 from "./DragBox4";
import DragBox5 from "./DragBox5";
import MobileSection3Inner from "./MobileSection3Inner";
import DragBox6 from "./DragBox6";
import { useThemeColor } from "../hooks/useThemeColor";

const Section3 = memo(({ index, width, section3Ref }) => {
  const [zindex, setzindex] = useState([1, 2, 3, 4, 5]);
  const themeColor = useThemeColor(index);

  const setZ = useCallback((cardIndex) => {
    const currentMaxZ = Math.max(...zindex);
    setzindex(prev => {
      const temp = [...prev];
      temp[cardIndex] = currentMaxZ + 1;
      return temp;
    });
  }, [zindex]);

  if (width > 768) {
    return (
      <div
        ref={section3Ref}
        className="flex items-center justify-center flex-col py-[100px] my-[100px] gap-[2rem]"
      >
        <h4 className="text-[70px] text-white tracking-[-5px] monospace">
          Discover <span style={{ color: themeColor }}>me</span>
        </h4>
        <div
          id="dragContainer"
          className="h-[650px] w-[90%] relative overflow-hidden"
        >
          <DragBox1 zindex={zindex} setZ={setZ} />
          <DragBox2 zindex={zindex} setZ={setZ} />
          <DragBox3 zindex={zindex} setZ={setZ} />
          <DragBox4 zindex={zindex} setZ={setZ} />
          <DragBox5 zindex={zindex} setZ={setZ} />
          <DragBox6 zindex={zindex} setZ={setZ} />
        </div>
      </div>
    );
  } else {
    return (
      <div className="flex items-center justify-center flex-col py-[200px] gap-[2rem]">
        <h4
          className={`text-white tracking-[-5px] monospace ${width > 768 ? "text-[70px]" : "text-[10vw]"}`}
        >
          Discover <span style={{ color: themeColor }}>me</span>
        </h4>
        <div className="">
          <MobileSection3Inner />
        </div>
      </div>
    );
  }
});

Section3.displayName = 'Section3';

export default Section3;
